import store from '@/store/store';

class LoadTables {

    constructor (currentRoute) {
        this.promises = [];
        this.currentRoute = currentRoute;
    }

    async load () {
        await Promise.all(this.promises);
    }

    async getPromises () {
        let user = api.currentUser;
        if (!api.currentUser) {
            user = await api.getCurrentUser();
        }
        if (user){
            store.commit('setUser', user);
            if (user && !this.currentRoute.meta.public) {
                api.setTable({table: "user", closed: "true"});
            }
        }

    }
}

export default LoadTables;